import { useEffect, useState } from 'react'

export const DEBOUNCE_BUSCA_MS = 450

export const useDebouncedValue = <T>(value: T, delay = DEBOUNCE_BUSCA_MS): T => {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(timer)
  }, [value, delay])

  return debounced
}
